export default __webpack_public_path__ + "static/media/icon_view.fbebe5b9.svg";